// import { useMemo } from 'react'


const getBackgroundsUrlsObj =  images => {
    const { poster, ambient, backgrounds } = images 
    const imgs = []

    if(ambient && ambient.url) {
        imgs.push(ambient)
    }

    if(backgrounds && Array.isArray(backgrounds)) {
        backgrounds.map(backImg => {
            if(backImg.url && -1 === imgs.findIndex(img => img.url === backImg.url)) {
                imgs.push(backImg)
            }
        })
    }

    let imgsLength = imgs.length

    if(0 === imgsLength && poster && poster.url) {
        imgs.push(poster)
        imgsLength = 1
    }

    if(0 === imgsLength) {
        return {
            ambient: false,
            performance: false,
            details: false
        }
    } else if(1 === imgsLength) {
        return {
            ambient:        imgs[0],
            performance:    imgs[0],
            details:        imgs[0]
        }
    } else if(2 === imgsLength) {
        return {
            ambient:        imgs[0],
            performance:    imgs[1],
            details:        imgs[1]
        }
    } else {
        return {
            ambient:        imgs[0],
            performance:    imgs[1],
            details:        imgs[2]
        }
    }
}


// const getBackgroundsUrlsObj = (images) => useMemo(
//     () => getBackgrounds(images), 
//     [images]
// )

export default getBackgroundsUrlsObj